import Model from 'flarum/common/Model';
export default class Ticket extends Model {
  subject = Model.attribute('subject');
  message = Model.attribute('message');
  status = Model.attribute('status');
  priority = Model.attribute('priority');
  attachment = Model.attribute('attachment');
  /** Slug derived from the subject, used to build /support/{id}/{slug} links. */
  slug = Model.attribute('slug');
  /** Raw answers to the admin-defined form fields, keyed by field name. */
  customFields = Model.attribute('customFields');
  /** Ready to display [{ label, value, type }] pairs. */
  customFieldValues = Model.attribute('customFieldValues');
  createdAt = Model.attribute('createdAt', Model.transformDate);
  updatedAt = Model.attribute('updatedAt', Model.transformDate);
  closedAt = Model.attribute('closedAt', Model.transformDate);
  user = Model.hasOne('user');
  category = Model.hasOne('category');
  assignee = Model.hasOne('assignee');
  replies = Model.hasMany('replies');
}
flarum.reg.add('cengizkemec-support-tickets', 'common/models/Ticket', Ticket);